import { Deserializable } from '../../../lib/models/deserializable';
import { MortgageClubDto } from './mortgage-club-dto.model';

export class MortgageClubsDto implements Deserializable {
  public AllowMortgageClubs: boolean;
  public MortgageClubSelectionCode: string;
  public MortgageClubs: Array<MortgageClubDto>;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.MortgageClubs = input.MortgageClubs.map((mortgageClubDto: MortgageClubDto) =>
      new MortgageClubDto().deserialize(mortgageClubDto)
    );

    return this;
  }
}
